/**
 * 服务
 */

import axios from '@/utils/request'

export default {
  getDocumentaryFile: (fileUrl, params) => axios({ url: fileUrl, method: 'GET', params, responseType: 'blob' }), // 获取跟单文件数据
  getDocumentaryFileList: (data) => axios({ url: '/api/message/documentaryFileList', method: 'POST', data }), // 获取跟单文件信息列表
  deleteDocumentaryFileList: (id, data) => axios({ url: `/api/message/documentaryFile/${id}`, method: 'DELETE', data }), // 删除跟单文件信息
  getDocumentaryFileDetails: (id, params) => axios({ url: `/api/message/documentaryFile/${id}`, method: 'GET', params }), // 获取跟单文件详情
  addOrEditDocumentaryFile: (data) => axios({ url: '/api/message/documentaryFile', method: 'PUT', data }), // 新增或编辑跟单文件
}
